export const iconFontAwesomeReligionMosque = (
	<i className="fa-solid fa-mosque"></i>
);
